/* Data-only bridge for the accepted cart seam. Load deferred AFTER the core.
 * No network, timer, native cart write, price/URL rendering or scheduler.
 */
(function(){
  'use strict';
  const core=window.MiniamiRecommendations;
  const sources=document.querySelectorAll('script[data-miniami-recommendations-data]');
  if(!core||typeof core.selectCurrent!=='function'||sources.length!==1) return;
  let snapshot;
  try { snapshot=JSON.parse(sources[0].textContent); } catch (_) { return; }
  if(!snapshot||snapshot.schema!=='miniami-c84-v1') return;
  // Match existing four-argument UI API; pure selector gets an explicit clock.
  window.MiniamiRecommendations=Object.freeze({
    select:(data,excluded,candidates,limit=3)=>core.selectCurrent(data,excluded,candidates,limit,Date.now()),
    selectCurrent:core.selectCurrent
  });
  window.MiniamiRecommendationSnapshot=snapshot;
  document.dispatchEvent(new CustomEvent('miniami:recommendations-ready',{bubbles:true}));
})();
